'use client';

import { FC } from 'react';

import { AspectRatio } from '@ravago/shared/radiance/components/aspect-ratio/components/AspectRatio/AspectRatio';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   searchTerm?: string;
}

export const ProductPortfolioEmpty: FC<Props> = ({ searchTerm }) => {
   const translate = useTranslations();

   const renderNoResultsText = (search: string | undefined) => {
      if (!search) return translate('products-no-results');

      // HACK: Fill translation param with a split key to allow for custom rendering
      const splitKey = '######SPLIT######';
      const translation = translate('products-no-search-results', { searchTerm: splitKey });
      const translationSplits = translation.split(splitKey);

      if (translationSplits.length !== 2) return translation;

      return (
         <>
            {translationSplits[0]}
            <strong>{search}</strong>
            {translationSplits[1]}
         </>
      );
   };

   return (
      <Box direction="column" items="center">
         <AspectRatio desktop="32:9" tablet="21:9" phone="21:9" width="100%">
            <svg style={{ width: '100%', height: '100%' }}>
               <use href="/illustrations/empty-state.svg#symbol" />
            </svg>
         </AspectRatio>
         <Typography variant="heading-1" align="center" color="strong">
            {translate('products-no-results-title')}
         </Typography>
         <Typography color="subtle" component="p">
            {renderNoResultsText(searchTerm)}
         </Typography>
      </Box>
   );
};
